export default __webpack_public_path__ + "static/media/send_black.56074323.svg";